import axios from 'axios';

// Thin client for the /api/v1/me* endpoints on backroom-server. Always
// attaches the caller's Firebase ID token; the caller is expected to fetch
// it via CustomerContext.idToken().

const baseUrl = process.env.REACT_APP_API_HOST as string;

export type CustomerAddress = {
  firstName?: string;
  lastName?: string;
  street?: string;
  additional?: string;
  city?: string;
  province?: string;
  postal?: string;
  country?: string;
  phone?: string;
};

export type Customer = {
  id: string;
  firebase_uid: string;
  email: string | null;
  email_verified: boolean;
  phone: string | null;
  display_name: string | null;
  default_delivery_address: CustomerAddress | null;
  default_billing_address: CustomerAddress | null;
  created_at: string;
  updated_at: string;
};

export type CustomerOrderSummary = {
  id: string;
  status: string;
  total: string;
  created_at: string;
};

const authHeaders = (idToken: string) => ({
  Authorization: `Bearer ${idToken}`,
});

export async function getMe(idToken: string): Promise<Customer> {
  const res = await axios.get(`${baseUrl}/api/v1/me`, {
    headers: authHeaders(idToken),
  });
  return res.data;
}

export type ProfilePatch = Partial<{
  phone: string;
  display_name: string;
  default_delivery_address: CustomerAddress;
  default_billing_address: CustomerAddress;
}>;

export async function patchMe(idToken: string, patch: ProfilePatch): Promise<Customer> {
  const res = await axios.patch(`${baseUrl}/api/v1/me`, patch, {
    headers: { ...authHeaders(idToken), 'Content-Type': 'application/json' },
  });
  return res.data;
}

export async function listMyOrders(
  idToken: string,
  opts: { limit?: number; offset?: number } = {},
): Promise<{ items: CustomerOrderSummary[]; limit: number; offset: number }> {
  const res = await axios.get(`${baseUrl}/api/v1/me/orders`, {
    headers: authHeaders(idToken),
    params: { limit: opts.limit, offset: opts.offset },
  });
  return res.data;
}
